import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
const _hoisted_2 = { class: "columns is-variable is-5" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "column is-narrow" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Caseworkers"),
    /*#__PURE__*/ _createElementVNode("h3", null, "Manage caseworkers")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_5 = { class: "column is-narrow pt-3" };
const _hoisted_6 = { class: "tabs is-toggle is-small mb-3" };
const _hoisted_7 = { style: { "justify-content": "right" } };
const _hoisted_8 = { class: "field" };
const _hoisted_9 = { class: "control" };
const _hoisted_10 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "50%" } }, "Caseworker Name", -1);
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "Select a partner", -1);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { key: 2 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { key: 0 };
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { computed, ref, watch } from "vue";
import { apiPartnerUsers } from "./api";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
import { User, Core } from "@minicity/core";
// Fetch caseworkers from API
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerUserListingPanel',
    setup(__props) {
        const partnerUsers = useAsync();
        // Search / category filtering
        const { searchQuery, filtered: filteredPartnerUsers } = useFilterForAsync(partnerUsers, (c) => `${c.partner.name} ${c.displayName}`);
        const activeCategory = ref("ALL");
        const partnerUsersToDisplay = computed(() => {
            return filteredPartnerUsers.value.filter(partnerUser => {
                if (activeCategory.value == "ALL")
                    return true;
                // Which specific statuses do we consider to be "active"?
                let isActive = partnerUser.shown && partnerUser.partner.shown;
                if (activeCategory.value == "ACTIVE" && !isActive)
                    return false;
                if (activeCategory.value == "HIDDEN" && isActive)
                    return false;
                return true;
            });
        });
        if (sessionState.session) {
            switch (sessionState.session.user.role) {
                case User.Role.NETWORK_ADMIN:
                    partnerUsers.fetch(apiPartnerUsers.getForNetwork(), "Failed to load partner users");
                    break;
                case User.Role.PARTNER_ADMIN:
                    partnerUsers.fetch(apiPartnerUsers.getForPartner(sessionState.session.partnerId), "Failed to load partner users");
                    break;
                default:
                    console.error("Unexpected user type");
                    break;
            }
        }
        const partnerId = ref(null);
        watch(partnerId, () => {
            partnerUsers.fetch(partnerId.value ? apiPartnerUsers.getForPartner(partnerId.value) : apiPartnerUsers.getForNetwork(), "Failed to load partner users");
        });
        return (_ctx, _cache) => {
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            return (_unref(isFeatureEnabled)('SITES'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createBlock(PartnerSelectField, {
                                key: 0,
                                modelValue: partnerId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((partnerId).value = $event)),
                                allowSelectAll: ""
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("ul", _hoisted_7, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ALL' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (activeCategory.value = 'ALL'))
                                        }, "All")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ACTIVE' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[2] || (_cache[2] = ($event) => (activeCategory.value = 'ACTIVE'))
                                        }, "Active")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'HIDDEN' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[3] || (_cache[3] = ($event) => (activeCategory.value = 'HIDDEN'))
                                        }, "Hidden")
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "input",
                                        type: "text",
                                        placeholder: "Search",
                                        autofocus: "",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                    }, null, 512), [
                                        [_vModelText, _unref(searchQuery)]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("table", _hoisted_10, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_11,
                                (_unref(isNetworkAdmin)())
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Partner"))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_unref(isNetworkAdmin)() && partnerId.value == 'none')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _hoisted_15))
                                : (_unref(partnerUsers).status == 'loading')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                        _createVNode(_component_LoadingTableRow)
                                    ]))
                                    : (partnerUsersToDisplay.value.length == 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(partnerUsersToDisplay.value, (partnerUser) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: partnerUser.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/partnerUsers/${partnerUser.id}`,
                                                        class: "horizontal"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_UserBadge, {
                                                                user: partnerUser,
                                                                disabled: !partnerUser.shown,
                                                                noLink: ""
                                                            }, null, 8, ["user", "disabled"]),
                                                            _createVNode(_component_OpenTasksIndicator, {
                                                                entityType: _unref(Core).EntityType['Partner User'],
                                                                entityId: partnerUser.id
                                                            }, null, 8, ["entityType", "entityId"])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                (_unref(isNetworkAdmin)())
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/partnerUsers/${partnerUser.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_PartnerBadge, {
                                                                    partner: partnerUser.partner,
                                                                    disabled: !partnerUser.partner.shown,
                                                                    noLink: ""
                                                                }, null, 8, ["partner", "disabled"])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
